import React from 'react';

/* mui */
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
/* mui */

/* CONSTANTS */
const useStyles = makeStyles(theme => ({
  paper: {
    backgroundColor: "#fff",
    padding: theme.spacing(3),
    textAlign: 'left',
    color: "black",
    marginTop: 15,
    marginBottom: 15,
    marginBottom:"0px!important"
   
    // width: "375px !important"
  },
}));
/* CONSTANTS */

const wrapper = props => {

var style = props.props;

  /* mui */
  const classes = useStyles();
  /* mui */

  return <Paper className={classes.paper} style={{display:style}}>
    { props.children }
  </Paper>
}

export default wrapper;
